<template>
  <div slot="activator">
    <slot
      name="activator"
      :label="label"
      :text="text"
      :prepend-icon="prependIcon"
      :append-icon="appendIcon"
      :open="open"
      :non-clearable="nonClearable"
      :disabled="disabled"
    >
      <DefaultFilterActivator
        :value="text"
        :label="label"
        :prepend-icon="prependIcon"
        :append-icon="appendIcon"
        :non-clearable="nonClearable"
        :disabled="disabled"
        @clear="reportClear"
      />
    </slot>
  </div>
</template>

<script setup>
import DefaultFilterActivator from "#ce/shared/filters/components/DefaultFilterActivator.ce.vue";

const emit = defineEmits(["clear"]);

function reportClear() {
  emit("clear");
}

defineProps({
  label: {
    type: String,
    required: true,
  },
  text: {
    type: String,
    default: undefined,
  },
  prependIcon: {
    type: String,
    default: undefined,
  },
  appendIcon: {
    type: String,
    default: undefined,
  },
  open: {
    type: Boolean,
    default: false,
  },
  nonClearable: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});
</script>
